export enum TypographyFontFamily {
  Regular = 'regular',
  SemiBold = 'semi-bold',
  Bold = 'bold'
}

export enum TypographyFontSize {
  Minor = 'minor',
  Smaller = 'smaller',
  XXXS = 'xxxs',
  XXS = 'xxs',
  XS = 'xs',
  SM = 'sm',
  RG = 'rg',
  MD = 'md',
  LG = 'lg'
}

export enum TypographyColor {
  Primary = 'primary',
  Secondary = 'secondary',
  Pay = 'pay',
  Neon = 'neon',
  Highlight = 'highlight',
  PrimeBranding = 'prime-branding',
  Success = 'success',
  Warning = 'warning',
  Error = 'error',
  ValueProp = 'value-prop',
  Disabled = 'disabled',
  Invert = 'invert',
}

export type TypographyTag = 'span' | 'p' | 'q' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | null;

export const TypographyDefaultTag = 'span';
